<script>
    import breakpoints from "../utils/breakpoints";
    import HeaderFilter from '../utils/ItemFilter.svelte';
    import ActionItem from "./responsiveactionitem.svelte";
    import Flatpickr from "../utils/Flatpickr.svelte";
    import { onMount } from 'svelte';
    import { init_data } from '../init.js';
    import { formatDate, getFormatDateByOffset, formatter } from '../utils/format.js';
    import { compute_rest_props } from "svelte/internal";


    const bp = breakpoints();

    export let table_filtered_function = undefined;
    export let show_csv_export = false;
    export let csv_name = undefined;
    export let show_date_range = false;
    export let show_search_box = true;
    export let show_pagination = true;
    export let date_filter_param = undefined;
    export let update_date_filter_status = undefined;
    export let set_date_range_obj = undefined;
    export let selected_word = 'items';
    export let from_date = '';
    export let to_date = '';
    export let init_type = '';
    export let refresh_action = '';
    export let is_busy = false;
    export let refresh_user_info = undefined;

    let formattedValue, flatpickr;
    export let date_value;
    export let date_range_options = {
		enableTime: false,
        dateFormat: "m/d/Y",
        mode: "range",
		onChange(selectedDates, dd, fp) {
            if (set_date_range_obj) { set_date_range_obj(fp); }
            from_date = selectedDates[0] ? formatDate(selectedDates[0]) : false;
            to_date = selectedDates[1] ? formatDate(selectedDates[1]) : false;
            if (from_date) {
                if (init_type === 'one_user') refresh_user_info(true);
                // else init_data('jobs');
                if (update_date_filter_status) { update_date_filter_status(true); }
            }
            formatData(table_data);
		},
		onOpen() {
			console.log('opened');
		},
        plugins: [
            ShortcutButtonsPlugin({
                button: [
                    {
                        label: "Clear"
                    },
                    {
                        label: "Yesterday"
                    },
                    {
                        label: "Today"
                    },
                    {
                        label: "Tomorrow"
                    }
                ],
                label: "",
                onClick: (index, fp) => {
                    if (init_type === 'one_user') refresh_user_info(true);
                    // else init_data('jobs');
                    if (set_date_range_obj) { set_date_range_obj(fp); }
                    let date;
                    switch (index) {
                        case 0:
                            if (update_date_filter_status) { update_date_filter_status(false); }
                            fp.clear();
                            fp.close();
                            break;
                        case 1:
                            if (update_date_filter_status) { update_date_filter_status(true); }
                            date = new Date(Date.now() - 24 * 60 * 60 * 1000);
                            from_date = formatDate(date);
                            to_date = formatDate(date);
                            formatData(table_data);
                            fp.close();
                            break;
                        case 2:
                            if (update_date_filter_status) { update_date_filter_status(true); }
                            date = new Date();
                            from_date = formatDate(date);
                            to_date = formatDate(date);
                            formatData(table_data);
                            fp.close();
                            break;
                        case 3:
                            if (update_date_filter_status) { update_date_filter_status(true); }
                            date = new Date(Date.now() + 24 * 60 * 60 * 1000);
                            from_date = formatDate(date);
                            to_date = formatDate(date);
                            formatData(table_data);
                            fp.close();
                            break;
                    }
                    fp.setDate(date);
                }
            })
        ]
	};
   
    export let num_per_page = 10;
    let num_per_page_options = [
		{ value: 10, text: "Show 10 Items" },
		{ value: 15, text: "Show 15 Items" },
		{ value: 25, text: "Show 25 Items" },
		{ value: 50, text: "Show 50 Items" },
		{ value: 100, text: "Show 100 Items" },
        { value: 500, text: "Show 500 Items" },
	];
    export let total_items = 0;
    let current_page = 0;
    let total_pages = 0;    

    function navTablePage(direction, amount){
        if(direction === 'p'){
            current_page -= amount;
            if(current_page < 0) current_page = 0;
        }

        if(direction === 'n'){
            current_page += amount;
            if(current_page > total_pages) current_page = total_pages;
        }

        formatData(table_data);
    }

    onMount(() => {
        for(let i = 0; i < table_data.length; i++){
            if(table_data[i].selection_marked === undefined){
                table_data[i].selection_marked = false;
            }
        }
    });

    let entry_search = "";
    let match_type = "any";
    let feed_back = "";
    let selection_feed_back = "";
    export let select_count = 0;

    export let show_selections = false;
    export let selections_selected = false;
    export let at_least_one_selected = false;
    export let selections_function = () => {
        if (is_busy) return;
        selections_selected = !selections_selected;
        for(let i = 0; i < filtered_item_indexes.length; i ++) {
            if (table_data[filtered_item_indexes[i]].s.toLowerCase() !== 'charged') {
                table_data[filtered_item_indexes[i]].selection_marked = selections_selected;
            }
        }

        select_count = table_data.filter((e) => {
            return (e.selection_marked !== undefined && e.selection_marked === true && e.status !== 'pending' && e.pt === 'Credit Card');
        }).length;

        if(select_count > 0){
            selection_feed_back = `${select_count} ${select_count > 1 ? selected_word + 's' : selected_word} selected`;
        }else{
            selection_feed_back = "";
        }
    };

    export let table_header_config = undefined;

    export let sort_functions = undefined;
    let header_sort_classes = undefined;
    function createHeaderButtons(thc){  
        let thb = thc.filter(e => e.a);
        header_sort_classes = new Array(thb.length).fill("sortable");
        
        return thb;
    }

    $: header_buttons = createHeaderButtons(table_header_config);
    function calculateHeaderDenominator(){
        let dem = header_buttons.length;
        if(action_items !== undefined) dem = dem + 1;
        if(show_selections) dem = dem + 1;
        return dem;
    }
    $: header_button_style_denominator = calculateHeaderDenominator(header_buttons, action_items);
    $: selected_items = table_data.filter(e => e.selection_marked);

    function doChangedSelection(evt) {
        if (is_busy) return;
        let tid = evt.target.id.substring(10);
        for(let i = 0; i < table_data.length; i++){
            if(table_data[i].id.toString() === tid.toString()){
                table_data[i].selection_marked = evt.target.checked;
            }
        }

        select_count = table_data.filter((e) => {
            return (e.selection_marked !== undefined && e.selection_marked === true && e.status !== 'pending' && e.pt === 'Credit Card');
        }).length;

        if(select_count > 0){
            selection_feed_back = `${select_count} ${select_count > 1 ? selected_word + 's' : selected_word} selected`;
            at_least_one_selected = true;
        }else{
            selection_feed_back = "";
            at_least_one_selected = false;
        }
    }

    function default_sort_function(a, b) {
        let nameA = a.toString().toUpperCase();
        let nameB = b.toString().toUpperCase();
        if (nameA[0] === '$') {
            nameA = parseFloat(nameA.replace(/\D/g,''));
            nameB = parseFloat(nameB.replace(/\D/g,''));
        }
        if ((nameA < nameB || nameA === '-')) { return -1; }
        if ((nameA > nameB || nameB === '-')) { return 1; }
        return 0;
    }

    function sortAxis(header_id, sc_index) {
        let sort_class = JSON.parse(JSON.stringify(header_sort_classes[sc_index]));
        header_sort_classes = new Array(header_buttons.length).fill("sortable");
        let is_ascending = true;
        if (sort_class === "sortable") {
            header_sort_classes[sc_index] = "asorted";
        }
        if (sort_class === "asorted") {
            header_sort_classes[sc_index] = "dsorted";
            is_ascending = false;
        }
        if (sort_class === "dsorted") {
            header_sort_classes[sc_index] = "asorted";
        }

        let the_sort_function = ((sort_functions !== undefined) && (header_id in sort_functions)) ? sort_functions[header_id] : default_sort_function;

        table_data  = table_data.sort((fo1, fo2) => {
            return the_sort_function(fo1[header_id], fo2[header_id])
        });

        if (!is_ascending) {
            table_data = table_data.reverse();
        }
    }

    function generateFieldMap(thc) {
        let tfield_map = {};
        for(let i = 0; i < header_buttons.length; i++){
            let hb = header_buttons[i];
            let tkey = hb.t;
            let tval = hb.t.toLocaleLowerCase().replace(/[^A-Za-z0-9 ]/g, '').match(/\b(\w)/g).join('');
            if('fm' in hb) {
                tval = hb.fm;
            }
            tfield_map[tkey] = tval;
        }
        return tfield_map;
    }
    $: field_map = generateFieldMap(table_header_config)

    export let table_data = undefined;

    export let field_formats = undefined;
    let formatted_data = undefined;

    let id2idxmap = {};
    function formatData(tdata, thc) {

        id2idxmap = {};
        for (let i = 0; i < tdata.length; i++) {
            id2idxmap[tdata[i].id] = i;
        }
        let thb = header_buttons;
        tdata = tdata.filter(item => (from_date && to_date && date_filter_param && item[date_filter_param])
            ? (new Date(from_date) <= new Date(item[date_filter_param].split(' - ')[0]) 
                && new Date(item[date_filter_param].split(' - ')[0]) <= new Date(to_date))
            : true);
        let res = tdata;
        if (tdata !== undefined && field_formats !== undefined) {
            let tformat_keys = thb.map(e => field_map[e.t]);

            res = tdata.map((nrow) => {
                let trow = {...nrow};
                tformat_keys.forEach(nk => {
                    if((nk in trow) && (nk in field_formats)) {
                        trow[`${nk}_o`] = trow[nk];
                        trow[nk] = field_formats[nk](trow[nk]);
                    } else {
                    }
                });
                return trow;
            });
        }
        if (entry_search !== undefined && entry_search.length > 0 && entry_search.trim().length > 0) {
            let tcmp = entry_search.toLocaleLowerCase().split(/\s+/);
            if (match_type === "any") {
                res = res.filter((e) => {
                    let is_there = false;
                    header_buttons.forEach(nb  => {
                        let tstr = (e[field_map[nb.t]] || '').toString().toLocaleLowerCase();
                        tcmp.forEach(nm => {
                            if(tstr.includes(nm)) {
                                is_there = true;
                            }
                        });
                    });
                    return is_there;
                });
            } else {
                let header_keys = thb.map(e => field_map[e.t]);
                res = res.filter((e) => {
                    let match_count = 0;
                    tcmp.forEach(nm => {
                        header_keys.forEach(nk => {
                            if(e[nk].toLocaleLowerCase().includes(nm)){
                                match_count ++;
                            }
                        });
                    });
                    return match_count >= tcmp.length;
                });
            }
        } else {
            feed_back = "";
        }
        filtered_item_indexes = [];
        for (let z = 0; z < res.length; z++) {
            filtered_item_indexes.push(id2idxmap[res[z].id]);
        }
        total_pages = Math.ceil(res.length / num_per_page);
        formatted_data = res.slice((current_page * num_per_page), (current_page * num_per_page + num_per_page));

        if (table_filtered_function !== undefined)  table_filtered_function(res);
    }
    let filtered_item_indexes = [];

    $: formatData(table_data, table_header_config);

    async function exportCSV() {
        const columns = table_header_config.map(header => header.t);
        const body = [columns];
        formatted_data.forEach(data => {
            const body_item = table_header_config.map(header => data[header.csv]);
            body.push(body_item.join(','));
        });
        if (statistic_data) {
            const statistic_item = table_header_config.map(header => statistic_data[header.csv] ? `"${statistic_data[header.csv]}"` : statistic_data[header.csv]);
            statistic_item[0] = 'Total';
            body.push(statistic_item);
        }

        const csv_file = body.join('\n');
        var blob = new Blob([csv_file]);
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        const csv_file_name = csv_name ? csv_name : 'payment_report';
        link.download = (from_date && to_date) ? `${csv_file_name} ${from_date.replaceAll('/', '-')} - ${to_date.replaceAll('/', '-')}.csv` : `${csv_file_name} ${getFormatDateByOffset(0)}.csv`;
        link.click();
    }

    export let field_styles = {};
    function generateStyleMap(thb, tstyles){
        let res = {};
        let tstyle_keys = thb.map(e => field_map[e.t]);
        tstyle_keys.forEach(nsk => {
            if(nsk in tstyles) {
                res[nsk] = tstyles[nsk];
            }
        });
        return res;
    }
    $: style_map = generateStyleMap(header_buttons, field_styles);

    export let action_items = undefined;
    export let hide_remove_column = undefined;
    export let show_items = undefined;
    export let action_items_title = 'Actions';
    export let statistic_data = undefined;
    export let onclick_action = undefined;
    
    let showing_total = "0";
    $: if(formatted_data !== undefined) {
        if (formatted_data.length > 0) {
            showing_total = "" + (current_page * num_per_page + 1) + "-" + (current_page * num_per_page + formatted_data.length);

            if (statistic_data && statistic_data !== undefined) {
                let total_prices = 0, total_contractor_prices = 0, total_profits = 0, total_hours = 0;
                for (let i = 0; i < formatted_data.length; i ++) {
                    const filtered_item = formatted_data[i];
                    total_prices += filtered_item.total_service_price;
                    total_contractor_prices += filtered_item.total_contractor_price;
                    total_profits += filtered_item.profit;
                    total_hours += filtered_item.hr;
                }
                statistic_data['p'] = formatter.format(total_prices);
                statistic_data['ud'] = formatter.format(total_contractor_prices);
                statistic_data['pt'] = formatter.format(total_profits);
                statistic_data['hr'] = total_hours;
            }
        } else {
            showing_total = "0";
            if (statistic_data) {
                statistic_data['p'] = formatter.format(0);
                statistic_data['ud'] = formatter.format(0);
                statistic_data['pt'] = formatter.format(0);
            }
        }
    }

    function triggerAction(ntd, hb) {
        if (onclick_action != undefined && field_map[hb.t] in onclick_action) {
            const action = onclick_action[field_map[hb.t]];
            if (`${field_map[hb.t]}_o` in ntd)
                action(ntd[`${field_map[hb.t]}_o`]);
            else 
                action(ntd[`${field_map[hb.t]}`]);
        }
    }

    const numFormatter = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    });
</script>

<div class="responsivetableholder">
    {#if show_search_box || show_date_range || show_csv_export}
    <div class="toolbar">
        {#if show_search_box }
        <div class="entrysearch">
            Search: <input type="text" on:keyup={() => {
                formatData(table_data);
            }} bind:value={entry_search}/>
        </div>
        {/if}
        &nbsp;
        {#if show_date_range }
        <div class="daterangesearch">
            Date Range: <Flatpickr options={date_range_options} bind:date_value bind:formattedValue bind:flatpickr />
        </div>                
        {/if}

        {#if show_csv_export }
        <div class="csv_export">
            <button on:click={()=>{exportCSV();}}><i class="fas fa-file-export"></i> Export CSV</button>
        </div>
        {/if}

        <!-- {#if refresh_action || refresh_user_info}
        <div class="refresh">
            <i class='fa fa-refresh' on:click={() => {
                if (refresh_action) {
                    is_busy = true;
                    init_data(refresh_action);
                    is_busy = false;
                }
                if (refresh_user_info) {
                    is_busy = true;
                    refresh_user_info(true);
                    is_busy = false;
                }
            }}></i>
        </div>
        {/if} -->
    </div>
    {/if}

    <div class="feedback">
        {feed_back}
    </div>
    <div class="feedback">
        {#if selected_items.length}
            {selection_feed_back}
        {/if}
    </div>

    <div class="subtoolbar"></div>
    <div class="fulltableholder">
        <div class="responsivetable">
            <div class="tabledataholder">
                <div class="tabledata">
                    <table>
                        <thead>
                            <tr>
                            {#if show_selections}
                            <th class="headerbuttonholder">
                                <button on:click={()=>{ selections_function(); }} disabled={is_busy}>
                                    <i class="far {(select_count === table_data.length || selections_selected) ? 'fa-check-square' : (select_count > 0 ? 'fa-minus-square' : 'fa-square')}"></i>
                                </button>
                            </th>
                            {/if}
                            {#if show_items !== undefined}
                            <th class="headerbuttonholder">
                                <button>Show</button>
                            </th>
                            {/if} 
                            <!-- header buttons -->
                            {#each header_buttons as nth, index}
                                {#if nth.a}
                                <th class="headerbuttonholder {sort_functions && sort_functions[nth.fm] === false ? '' : header_sort_classes[index]}">
                                    <button on:click={() => {sortAxis(field_map[nth.t], index)}} >{nth.t}</button>
                                </th>
                                {/if}
                            {/each}
                            <!-- tools if they are there -->
                            {#if action_items !== undefined && !hide_remove_column}
                            <th class="headerbuttonholder">
                                <button>{action_items_title}</button>
                            </th>
                            {/if}
                            </tr>
                        </thead>

                        {#each formatted_data as ntd, index}
                        <tr>
                            {#if show_selections}
                                {#if ntd.status !== 'charged' && ntd.status !== 'pending' && ntd.pt === 'Credit Card' && ntd.status !== 'not_assigned'}
                                    <td class="selectionholder">
                                        <input 
                                            style="width: 12px;"
                                            id="selection_{ntd.id}" 
                                            type="checkbox" 
                                            checked={(ntd.selection_marked) ? true: false}
                                            on:change={(e) => {doChangedSelection(e);}}
                                            disabled={is_busy}
                                        />
                                    </td>
                                {:else}
                                    <td class="selectionholder"></td>
                                {/if}
                            {/if}
                            {#if show_items !== undefined}
                                <td style="width:calc(100% /{header_button_style_denominator});">
                                    <ActionItem
                                        action_id={ntd.id}
                                        bind:action_items={show_items}
                                    />
                                </td>
                            {/if}
                            {#each header_buttons as hb, index}
                                {#if $bp === "desktop"}
                                <td 
                                    class="" 
                                    style="width:calc(100% /{header_button_style_denominator}); {(field_map[hb.t] in style_map) ? style_map[field_map[hb.t]] : ""}"
                                    on:click={()=>{ triggerAction(ntd, hb) }}
                                >
                                    {@html ntd[field_map[hb.t]]}
                                </td>
                                {:else}
                                <td 
                                    class="" 
                                    style="{(field_map[hb.t] in style_map) ? style_map[field_map[hb.t]] : ""}"
                                    on:click={()=>{ triggerAction(ntd, hb) }}
                                >
                                    {@html ntd[field_map[hb.t]]}
                                </td>
                                {/if}
                            {/each}
                            {#if action_items !== undefined && !hide_remove_column}
                                {#if !ntd.not_allowed}
                                <td style="width:calc(100% /{header_button_style_denominator});max-width: 100px;">
                                    <ActionItem
                                        action_id={ntd.id}
                                        bind:action_items={action_items}
                                    />
                                </td>
                                {:else}
                                <td></td>
                                {/if}
                            {/if}
                        </tr>
                        {/each}

                        {#if statistic_data !== undefined}
                        <tr>
                            {#if show_selections}
                                <td></td>
                            {/if}
                            {#if show_items !== undefined}
                                <td>Total</td>
                            {/if}
                            {#each header_buttons as hb}
                            {#if $bp === "desktop"}
                                <td class="wrapword" style="width:calc(100% /{header_button_style_denominator}); {(field_map[hb.t] in style_map) ? style_map[field_map[hb.t]] : ""}">{@html statistic_data[field_map[hb.t]]}</td>
                                {:else}
                                <td class="wrapword" style="{(field_map[hb.t] in style_map) ? style_map[field_map[hb.t]] : ""}">{@html statistic_data[field_map[hb.t]]}</td>
                                {/if}
                            {/each}
                            {#if action_items !== undefined}
                                <td></td>
                            {/if}
                        </tr>
                        {/if}
                    </table>
                </div>
            </div>
        </div>
     
    </div>

    {#if show_pagination}
    <div class="iteminformation">
        <div class="itemrange">Showing {showing_total} of {numFormatter.format(total_items)} total items.</div>
        <!-- <div class="itemrange">Showing {current_page * num_per_page + 1} - {current_page * num_per_page + formatted_data.length} of {total_items} total items.</div> -->
        <div class="tablenav">
            <button disabled={(current_page - 100) < 0} on:click={() => {navTablePage('p', 10);}}><i class="fas fa-angle-double-left"></i></button>
            <button  disabled={(current_page - 1) < 0} on:click={() => {navTablePage('p', 1);}}><i class="fas fa-angle-left"></i></button>
            <button disabled={(current_page + 1) >= total_pages} on:click={() => {navTablePage('n', 1);}}><i class="fas fa-angle-right"></i></button>
            <button disabled={(current_page + 100) >= total_pages} on:click={() => {navTablePage('n', 10);}}><i class="fas fa-angle-double-right"></i></button>
        </div>
    </div>

    <div class="bottomtoolbar">
        <div class="entrycount">
            <select bind:value={num_per_page} on:change={() => {formatData(table_data)}}>
                {#each num_per_page_options as npo}
                <option value="{npo.value}">{npo.text}</option>
                {/each}
            </select>
        </div>
        <div class="headerselection">
            <HeaderFilter title="Filters" bind:filter_items={table_header_config} />
        </div>
    </div>
    {/if}
</div>


<style>
    .fa.fa-refresh:before { content: "\f021"; }
    .fa-refresh { cursor: pointer; }
    .refresh {
        position: absolute;
        right: 15px;
    }
    .wrapword {
        white-space: -moz-pre-wrap !important;  /* Mozilla, since 1999 */
        white-space: -webkit-pre-wrap;          /* Chrome & Safari */ 
        white-space: -pre-wrap;                 /* Opera 4-6 */
        white-space: -o-pre-wrap;               /* Opera 7 */
        white-space: pre-wrap;                  /* CSS3 */
        word-wrap: break-word;                  /* Internet Explorer 5.5+ */
        word-break: break-all;
        white-space: normal;
    }
    .fulltableholder {
        width: 100%;
        margin: 0px;
        padding: 0px;
    }
    .responsivetableholder {
        width: 100%;
    }
    .responsivetable {
        width: 100%;
        display: grid;
        grid-template-columns: 1fr;
        grid-template-rows: auto;
        margin-top: 20px;

    }
    .toolbar {
        position: relative;
        width: 100%;
        display: flex;
        flex-direction: row;
        /* justify-content: space-between; */
        align-items: center;
        padding-top: 10px;
        padding-bottom: 10px;
    }
    .entrysearch input{
        max-width: 200px;
    }
    .csv_export {
        padding-left: 10px;
        padding-right: 10px;
    }
    .csv_export button{
        width: 150px;
        background-color: #1769aa;
        color: white;
    }
    .feedback {
        width: 100%;
        color: cornflowerblue;
        font-weight: bold;
    }
    th.headerbuttonholder {
        padding: 0px;
    }

    th.headerbuttonholder button {
        width: 100%;
        margin: 0px;
        display: inline-block;
        background-color: rgb(241, 241, 241);
    }
    th.headerbuttonholder.sortable button::after {
        font-family: "Font Awesome 5 Pro"; font-weight: 900; content: "\f338";
        z-index: 60;
        float: right;
    }
    th.headerbuttonholder.asorted button::after {
        font-family: "Font Awesome 5 Pro"; font-weight: 900; content: "\f309";
        z-index: 60;
        float: right;
    }
    th.headerbuttonholder.dsorted button::after {
        font-family: "Font Awesome 5 Pro"; font-weight: 900; content: "\f30c";
        z-index: 60;
        float: right;
    }
    .tabledataholder {
        width: 100%;
        height: 100%;
    }
    .tabledata {
        width: 100%;
    }
    .tabledata table {
        width: 100%;
    }
    .tabledata td {
        width: auto !important;    
    }
    .tabledata table, .tabledata td {
        border: solid 1px #999;
        border-collapse: collapse;        
    }
    .tabledata, .tabledata td {
        border-right: none;
        border-left: none;
    }
    .tabledata td {
        padding: 10px
    }
    .tabledata tr:nth-child(odd) {
    background-color: #f2f2f2;
    }
    .iteminformation {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 10px;
    }
    .itemrange {
        color: #666;
        font-style: italic;
        font-size: 15px;
    }
    .tablenav {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
    .tablenav button {
        margin-left: 10px;
        margin-right: 10px;
        cursor: pointer;
    }
    .selectionholder {
        text-align: center;
    }
    .bottomtoolbar {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 10px;
    }
    @media (max-device-width: 1024px), (max-width: 1023px) {
        .toolbar {
            width: 100%;
            display: flex;
            flex-direction: column;
            padding-top: 10px;
            padding-bottom: 10px;
        }
        .entrycount {
            width: 100%;
        }
        .entrycount select{
            width: 100%;
        }
        .entrysearch {
            width: 100%;
        }
        .entrysearch input[type="text"] {
            max-width: 100%;
            width: 100%;
        }
        .headerselection {
            width: 100%;
        }

        .fulltableholder {
            padding: 0px;
            margin: 0px;
            box-sizing: border-box;
            width: 100%;
            overflow-x: scroll;
            -webkit-overflow-scrolling: touch;
        }
        .tabledata {
            padding: 0px;
            margin: 0px;
            box-sizing: border-box;
            width: max-content;
            min-width: 100%;
            overflow: hidden;
        }
        .tabledata tr, .tabledata td {
            max-width: 600px;
        }
        .bottomtoolbar {
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            margin-top: 10px;
        }

        .daterangesearch {
            width: 100%;
        }
        .csv_export {
            width: 100%;
            padding-left: 0px;
            padding-right: 0px;
        }
        .csv_export button{
            width: 100%;
            background-color: #1769aa;
            color: white;
        }
    }
</style>